import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { NavBar } from 'components/NavBar/NavBar'
import { NoData } from 'components/NoData'
import { Button } from 'components/ui/Button/Button'
import { Flex, PageWrapper } from 'styling/GlobalStyles'
import { OtherText } from 'styling/Typography'
import { USE_OPS_MOCKS } from '../Shared/opsControl'
import { deptByKey } from '../Shared/opsDepartments'
import { DemoBadge } from '../Shared/OpsSharedComponents'
import { EnvironStrip } from './EnvironStrip'
import { TodayQuestionCard } from './TodayQuestionCard'
import { TodayInbox } from './TodayInbox'
import { TodaySwitcher } from './TodaySwitcher'
import { RaiseRequestModal } from './RaiseRequestModal'
import { RequestsSentByDept, RequestsToDept } from './TodayRequests'
import { buildDeptCards, deptInboxItems } from './todayData'
import { QuestionsGrid, TodayTitle } from './OpsToday.styled'

export const DeptToday = () => {
  const { deptKey } = useParams()
  const dept = deptByKey(deptKey || '')
  const [raiseOpen, setRaiseOpen] = useState(false)

  if (!USE_OPS_MOCKS) {
    return (
      <>
        <NavBar />
        <PageWrapper>
          <TodayTitle>Today</TodayTitle>
          <NoData text='Your shift view will come alive once the site is connected.' />
        </PageWrapper>
      </>
    )
  }

  if (!dept) {
    return (
      <>
        <NavBar />
        <PageWrapper>
          <TodayTitle>Today</TodayTitle>
          <TodaySwitcher activeKey={deptKey || ''} />
          <NoData text='This department is not set up yet.' />
        </PageWrapper>
      </>
    )
  }

  const cards = buildDeptCards(dept)

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex between center width='100%'>
          <Flex center gap='0.75rem'>
            <TodayTitle>{dept.name}</TodayTitle>
            <DemoBadge />
          </Flex>
          <Button variant='primary' onClick={() => setRaiseOpen(true)}>
            Raise request
          </Button>
        </Flex>
        <OtherText grey>Day Shift · 06:00–18:00</OtherText>
        <TodaySwitcher activeKey={dept.key} />
        <EnvironStrip />
        <QuestionsGrid>
          {cards.map((card) => (
            <TodayQuestionCard key={card.id} card={card} />
          ))}
        </QuestionsGrid>
        <RequestsToDept dept={dept} />
        <TodayInbox key={dept.key} initialItems={deptInboxItems(dept.key)} />
        <RequestsSentByDept dept={dept} />
        {raiseOpen && <RaiseRequestModal dept={dept} closeModal={() => setRaiseOpen(false)} />}
      </PageWrapper>
    </>
  )
}
